import {GridBaseDataProvider} from "../../../grid/GridBaseDataProvider";
import {Column, ColumnKeys} from "../types/filter-data";
import {SetFiltersRequest} from "../../../grid/types/common";
import {
  API_TYPE_INTEGRATIONS_MARKETPLACE
} from "../../../webcomponents.constants";

export class IntegrationsMarketplaceGridFilterNirvanaDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {

  public companyFilterDataProvider = API_TYPE_INTEGRATIONS_MARKETPLACE;

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return;
  }

}
